/**
 * @module app.ext.cwqi
 */

import { autoinject, computedFrom } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { CwqiManager } from 'app/ext/cwqi/cwqi-manager';
import { AuthPageContext } from 'app/um/lib/auth-page-context';
import * as UM from 'app/um/models/essette-api';


@autoinject()
export class ExtCwqi {

    ////****************** Fields and Properties ************************************////
    @bindable
    protected auth: UM.Auth | null = null;
    @bindable
    protected diagnosis: UM.AuthDiagnosis | null = null;
    @bindable
    protected service: UM.AuthService | null = null;

    @bindable
    protected readonly: boolean = false;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        protected readonly cwqi: CwqiManager,
        private readonly context: AuthPageContext) {
    }
    protected bind(): void {
        if(!this.auth) { this.auth = this.context.auth; }
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    protected open(): void {
        if(!this.auth) return;

        if(this.diagnosis) {
            this.cwqi.open(this.context.apiSettings, this.auth, this.diagnosis);
        } else if(this.service) {
            this.cwqi.open(this.context.apiSettings, this.auth, this.service);
        }
    }

    @computedFrom('diagnosis', 'service')
    protected get getCode(): string {
        if(this.diagnosis) {
            return this.diagnosis.definition?.code ?? '';
        } else if(this.service) {
            return this.service.definition?.code ?? '';
        } else {
            return '';
        }
    }

    @computedFrom('diagnosis', 'service')
    protected get getSource(): string {
        if(this.diagnosis) {
            return 'um:auth.diagnosis.code.$long';
        } else if(this.service) {
            return 'um:service.code.$long';
        } else {
            return 'um:service.code.$';
        }
    }

    ////****************** Service Calls ********************************************////

}
